"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BasicCard = _interopRequireDefault(require("./templates/BasicCard/BasicCard"));
var _BasicCardCollapse = _interopRequireDefault(require("./templates/BasicCard/BasicCardCollapse"));
var _ImageCard = _interopRequireDefault(require("./templates/ImageCard/ImageCard"));
var _ListCard = _interopRequireDefault(require("./templates/ListCard/ListCard"));
var _GraphicsCard = _interopRequireDefault(require("./templates/GraphicsCard/GraphicsCard"));
var _InfoCard = _interopRequireDefault(require("./templates/InfoCard/InfoCard"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var templates = {
  BasicCard: _BasicCard["default"],
  ImageCard: _ImageCard["default"],
  ListCard: _ListCard["default"],
  GraphicsCard: _GraphicsCard["default"],
  BasicCardCollapse: _BasicCardCollapse["default"],
  InfoCard: _InfoCard["default"]
};
var OriginalCard = function OriginalCard(props) {
  var TemplateSelected = templates[props.template];
  var noComponentPadding = props.noComponentPadding || ['Video', 'DestinationVideo'].includes(props.imageCardTemplate) || props.image;
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: props.intersectionRef,
    className: (0, _classnames["default"])('d8-c-card', !props.bgColor ? 'd8-u-white-bg' : props.bgColor, 'd8-u-bg-img', 'd8-u-relative', 'd8-u-radius-md', props.onClick && 'd8-u-hover', props.hover && 'd8-c-card-hover', props.className, {
      'height-100%': props.fullHeight,
      '--active': props.on,
      'd8-u-component-padding': !noComponentPadding
    }, props.size, props.disabled && 'disabled'),
    role: props.bgImage.url && 'img',
    "aria-label": props.bgImage.alt || props.bgImage.title,
    style: _objectSpread({
      backgroundImage: props.bgImage.url ? "url(".concat(props.inView ? props.bgImage.url : '', ")") : null
    }, props.style),
    onClick: props.onClick
  }, props.overlay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-overlay d8-u-radius-md"
  }), /*#__PURE__*/_react["default"].createElement(TemplateSelected, props));
};
OriginalCard.propTypes = {
  template: _propTypes["default"].string,
  imageCardTemplate: _propTypes["default"].string,
  bgImage: _propTypes["default"].object,
  image: _propTypes["default"].object,
  bgColor: _propTypes["default"].string,
  heading: _propTypes["default"].string,
  className: _propTypes["default"].string,
  overlay: _propTypes["default"].bool,
  on: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  fullHeight: _propTypes["default"].bool,
  inView: _propTypes["default"].bool,
  intersectionRef: _propTypes["default"].func,
  style: _propTypes["default"].object,
  size: _propTypes["default"].string,
  hover: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  noComponentPadding: _propTypes["default"].bool
};
OriginalCard.defaultProps = {
  template: 'BasicCard',
  overlay: false,
  fullHeight: false,
  bgImage: {}
};
var _default = exports["default"] = OriginalCard;